import React, { type FC } from "react";

import { IconErrorOutlined } from "~/components/icon";
import { isError } from "~/tools/is-error";

import { isHTTPError } from "../../generic/request";
import { DrawerTitle, ExplorationDrawer } from "../react/drawer/ExplorationDrawer";
import { Markdown } from "../react/markdown/Markdown";

export interface ErrorDetailsDrawerState {
	error: unknown;
}

export interface ErrorDetailsDrawerProps {
	when: undefined | ErrorDetailsDrawerState;
}

export const ErrorDetailsDrawer: FC<ErrorDetailsDrawerProps> = ({ when }) => (
	<ExplorationDrawer
		data-testid="error-details-drawer"
		headerTitle={({ error }) => {
			const title = isHTTPError(error) ? error.statusText || "Unknown Error" : "Error";

			return <DrawerTitle icon={<IconErrorOutlined className="text-red-500" height={20} width={20} />} title={title} />;
		}}
		layout="compact"
		when={when}
	>
		{({ error }) => (
			<div className="space-y-6">
				<p className="m-0 text-13">{isError(error) ? error.message : "Unknown Error"}</p>
				{isHTTPError(error) && (
					<>
						{error.data != null ? (
							<div>
								<Subtitle>Error Data</Subtitle>
								<Markdown copyCodeToClipboard text={JSON.stringify(error.data)} trimText />
							</div>
						) : null}

						{error.apiErrors && error.apiErrors.length > 0 && (
							<div>
								<Subtitle>Error Trace</Subtitle>

								<Markdown
									className="prose-pre:mt-4 prose-pre:rounded-sm! prose-pre:border-red-300! prose-pre:bg-red-100! prose-pre:p-3!"
									copyCodeToClipboard
									text={["```json", JSON.stringify(error.apiErrors, null, 2), "```"].join("\n")}
									trimText
								/>
							</div>
						)}
					</>
				)}
			</div>
		)}
	</ExplorationDrawer>
);

const Subtitle: React.FC<React.PropsWithChildren> = (props) => (
	<div {...props} className="font-medium text-15 text-gray-900 leading-5.5" />
);
